<template>
  <div>
    <pxkeji-rightHeader />
    <a-tabs :defaultActiveKey="0" :animated="{inkBar:true, tabPane:false}">
      <a-tab-pane tab="财务报表" :key="0" forceRender>
        <div class="pxkeji-right-box">

          <a-form v-model="searchForm" class="ant-advanced-search-form">
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="子站集合">
                  <a-select show-search :filter-option="filterOption" v-model="searchForm.data_zone" mode="multiple"
                            allowClear>
                    <a-select-option :value="subinfo.id" v-for="(subinfo, index) in where.subsites"
                                     :key="index + '--' + subinfo.name">{{ subinfo.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="时间区间">
                  <a-range-picker format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" v-model="searchForm.rangTime" />
                </a-form-item>
              </a-col>

              <a-col :span="6">
                <a-form-item label="用户组">
                  <a-select show-search v-model="searchForm.groupIds" :disabled="searchForm.data_zone.length!=1" :filter-option="filterOption" allowClear>
                    <a-select-option :value="info.id" v-for="(info, index) in tableList.grouplist" :key="index">{{ info.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :span="6">
                <a-form-item label="所在地区">
                  <a-cascader :options="where.areas" placeholder="请选择所在地区" change-on-select v-model="searchForm.areas"
                               :fieldNames="{ label: 'name', value: 'name', children: 'children' }" />
                </a-form-item>
              </a-col>


            </a-row>
            <a-row :gutter="24">

              <a-col :span="6">
                <a-form-item label="主管部门">
                  <a-select show-search v-model="searchForm.administration" :disabled="searchForm.data_zone.length!=1" :filter-option="filterOption" allowClear>
                    <a-select-option :value="info.itemName" v-for="(info, index) in where.administrationList"
                                     :key="index">{{ info.itemName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item label="单位名称">
                  <a-input placeholder="请输入单位名称" v-model="searchForm.enterpriseName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="注册方式">
                  <a-select v-model="searchForm.sourceType" :filter-option="filterOption" allowClear
                            @change="howToRegisterChange">
                    <a-select-option :value="item.value" v-for="item in where.howToRegisterList" :key="item.name + item.value">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :span="2" :style="{ textAlign: 'left' }">
                <a-button type="primary" @click="search" >搜索</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <div class="pxkeji-right-box">
          <pxkeji-btn name="导出" class="pxkeji_basic_btn" @click="exportStatistics" v-btnlimit="'财务统计-导出'" />

          <a-table :columns="tableList.columns" rowKey="id" :pagination="false"
                   :dataSource="tableList.data" :loading="tableList.loading"  bordered>
            <span slot="totalMoney" slot-scope="totalMoney">{{ totalMoney.basicMoney + totalMoney.presentMoney }}</span>

            <span slot="amount" slot-scope="text,record">
              <span v-if="record.type==1||record.type==3">{{record.amount}}</span>
              <span v-else>-{{record.amount}}</span>
            </span>

            <span slot="method" slot-scope="paymentMethod">
          <a-tag v-if="paymentMethod == 'wechatapp'" color="green">微信APP</a-tag>
          <a-tag v-else-if="paymentMethod == 'wechatqr'" color="green">微信扫码</a-tag>
          <a-tag v-else-if="paymentMethod == 'alipayapp'" color="green">支付宝App</a-tag>
          <a-tag v-else-if="paymentMethod == 'alipayqr'" color="green">支付宝扫码</a-tag>
          <a-tag v-else-if="paymentMethod == '线下支付'" color="green">线下支付</a-tag>
          <a-tag v-else-if="paymentMethod == 'wallet'" color="green">余额支付</a-tag>
          <a-tag v-else-if="paymentMethod == 'wechatjs'" color="green">微信支付</a-tag>
          <a-tag v-else-if="paymentMethod == 'chinaums'" color="green">银联商务</a-tag>
          <a-tag v-else-if="paymentMethod == 'xbsd'" color="#079DEA">移动支付(西北师大)</a-tag>
          <a-tag v-else-if="paymentMethod == 'jilin'" color="#079DEA">移动支付(长春工大)</a-tag>
          <a-tag v-else-if="paymentMethod == 'jiuzhou'" color="#079DEA">移动支付(四川九洲)</a-tag>
          <a-tag v-else-if="paymentMethod == 'cqut'" color="#079DEA">移动支付(重庆理工)</a-tag>
          <a-tag v-else-if="paymentMethod == 'zhixiao'" color="#079DEA">移动支付(知校)</a-tag>
          <a-tag v-else-if="paymentMethod == 'sxu'" color="#079DEA">移动支付(山西大学)</a-tag>
          <a-tag v-else-if="paymentMethod == 'sxxz'" color="#079DEA">移动支付(山西忻州)</a-tag>
          <a-tag v-else-if="paymentMethod == 'gsnx'" color="#079DEA">移动支付(甘肃农信)</a-tag>
          <a-tag v-else-if="paymentMethod == 'gsdk'" color="#079DEA">移动支付(甘肃地矿)</a-tag>
        <a-tag v-else-if="paymentMethod == 'sczj'" color="#079DEA">移动支付(成都理工)</a-tag>
        <a-tag v-else-if="paymentMethod == 'ggzj'" color="#079DEA">移动支付(桂林理工)</a-tag>
        <a-tag v-else-if="paymentMethod == 'sczj'" color="#079DEA">移动支付(南京工业)</a-tag>
        <a-tag v-else-if="paymentMethod == 'njkc'" color="#079DEA">移动支付(南京勘察)</a-tag>
        <a-tag v-else-if="paymentMethod == 'yzzj'" color="#079DEA">移动支付(扬州专技)</a-tag>
        <a-tag v-else-if="paymentMethod == '余额充值'" color="#b502ea">余额充值</a-tag>
        <a-tag v-else-if="paymentMethod == 'ghatg'" color="#079DEA">移动支付(公航旅)</a-tag>
        <a-tag v-else-if="paymentMethod == 'jszj'" color="#079DEA">移动支付(南京工业)</a-tag>
              <a-tag v-else-if="paymentMethod == 'zjnl'" color="#079DEA">移动支付(农林大)</a-tag>
        <a-tag v-else-if="paymentMethod == 'heu'" color="#079DEA">移动支付(哈工程)</a-tag>
        <a-tag v-else-if="paymentMethod == 'hnnj'" color="#079DEA">移动支付(湖南南京)</a-tag>
        <a-tag v-else-if="paymentMethod == 'szu'" color="#079DEA">移动支付(深大)</a-tag>

        </span>

          </a-table>
        </div>
      </a-tab-pane>
      <a-tab-pane tab="财务详情" :key="1">
        <div class="pxkeji-right-box">
          <a-form class="ant-advanced-search-form">
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="子站集合">
                  <a-select show-search :filter-option="filterOption" v-model="where.keyword.dataZone" mode="multiple"
                            allowClear @change="changeDataZone">
                    <a-select-option :value="subinfo.id" v-for="(subinfo, index) in where.subsites"
                                     :key="index + '--' + subinfo.name">{{ subinfo.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="付款时间">
                  <a-range-picker @change="onTimeChange" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="订单编号">
                  <a-input placeholder="请输入" v-model="where.keyword.orderId" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="用户信息">
                  <a-input placeholder="请输入用户名/姓名/身份证号/手机号" v-model="where.keyword.name" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="6">
                <a-form-item label="支付类型">
                  <a-cascader v-model="where.keyword.payMethod" :options="baseConfig.pay_method_cast"
                              :fieldNames="{ label: 'title', value: 'label', children: 'children' }" @change="paymentMethodChanged"
                              change-on-select expandTrigger="hover" placeholder="请选择支付方式" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="用户组">
                  <a-select :disabled="statusList.groupDisableStatus" show-search v-model="where.keyword.groupId"
                            :filter-option="filterOption" allowClear @change="groupChanged">
                    <a-select-option :value="info.id" v-for="(info, index) in where.grouplist" :key="index">{{ info.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="主管部门">
                  <a-select :disabled="statusList.adminStatus" show-search v-model="where.keyword.administration"
                            :filter-option="filterOption" allowClear @change="administrationChanged">
                    <a-select-option :value="info.itemName" v-for="(info, index) in where.administrationList"
                                     :key="index + info.itemName">{{ info.itemName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="所在地区">
                  <a-cascader :options="where.areas" placeholder="请选择所在地区" change-on-select @change="onAreachange"
                              :fieldNames="{ label: 'name', value: 'name', children: 'children' }" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="单位名称">
                  <a-input placeholder="请输入" v-model="where.keyword.enterpriseName" />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="注册方式">
                  <a-select v-model="searchForm.sourceType" :filter-option="filterOption" allowClear
                            @change="howToRegisterChange">
                    <a-select-option :value="item.value" v-for="item in where.howToRegisterList" :key="item.name + item.value">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="2" :style="{ textAlign: 'left' }">
                <a-button type="primary" @click="searchList" style="margin-top: 3px;">搜索</a-button>
              </a-col>
            </a-row>
          </a-form>
        </div>

        <div class="pxkeji-right-box">
          <a-button type="primary" class="pxkeji_basic_btn" @click="exportData" style="margin-bottom: 10px;"
                    v-btnlimit="'子站财务数据-导出'">导出数据</a-button>
          <div class="totalbox" style="float: right;">
            <div>
              <span>本页合计金额：{{ info.subtotal }}元 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 总订单数：{{ info.totalCount }}个
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 人数：{{ info.renshu }}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 总金额：{{ info.totalPrice }}元</span>
            </div>
          </div>
          <a-table :columns="list.columns" rowKey="id" :pagination="list.pagination" @change="pageChange"
                   :dataSource="list.datas" :loading="isloading" :locale="{ emptyText: '请按需求筛选后，点击搜索' }">
            <span slot="dataZoneName" slot-scope="dataZoneName">
              <span>{{ dataZoneName ? dataZoneName : '总站数据' }}</span>
            </span>
            <span slot="status" slot-scope="status">
              <a-tag v-if="status.status" color="green">启用</a-tag>
              <a-tag v-else color="red">禁用</a-tag>
            </span>
            <span slot="paymentMethod" slot-scope="paymentMethod">
              <a-tag v-if="paymentMethod == 'wechatapp'" color="green">微信APP</a-tag>
              <a-tag v-else-if="paymentMethod == 'wechatqr'" color="green">微信扫码</a-tag>
              <a-tag v-else-if="paymentMethod == 'wechatjs'" color="green">微信支付</a-tag>
              <a-tag v-else-if="paymentMethod == 'chinaums'" color="orange">银联商务</a-tag>
              <a-tag
                  v-else-if="paymentMethod == 'jiuzhou' ||paymentMethod == 'jilin' || paymentMethod == 'xbsd' || paymentMethod == 'zhixiao' ||
                paymentMethod == 'sxu' || paymentMethod == 'sxxz' || paymentMethod == 'gsnx' || paymentMethod == 'gsdk' || paymentMethod == 'hnnj' ||paymentMethod == 'szu' ||
                paymentMethod == 'njkc' || paymentMethod == 'sczj' || paymentMethod == 'ggzj' || paymentMethod == 'jszj' ||paymentMethod == 'yzzj' || paymentMethod == 'ghatg' || paymentMethod == 'zjnl' || paymentMethod == 'heu'"
                  color="orange">移动支付</a-tag>
              <a-tag v-else-if="paymentMethod == 'alipayapp'" color="blue">支付宝APP</a-tag>
              <a-tag v-else-if="paymentMethod == 'alipayqr'" color="blue">支付宝扫码</a-tag>
              <a-tag v-else-if="paymentMethod == 'wallet'" color="orange">余额支付</a-tag>
              <a-tag v-else-if="paymentMethod == 'cqut'" color="orange">移动支付</a-tag>
              <a-tag v-else color="cyan">线下支付</a-tag>
            </span>
            <span slot="source" slot-scope="source">
              <a-tag v-if="source == 'order'" color="#f50">直接支付</a-tag>
              <a-tag v-else-if="source == 'recharge'" color="#f50">余额支付</a-tag>
            </span>
          </a-table>
          <div class="totalbox" style="float: left;">
            <div>
              <span>共有：{{ list.pagination.total }}条数据</span>
            </div>
          </div>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
var that;
const columns = [
  {
    dataIndex: "dataZoneName",
    key: "dataZoneName",
    align: "center",
    title: "站点",
    scopedSlots: { customRender: "dataZoneName" }
  },
  {
    dataIndex: "id",
    key: "id",
    align: "center",
    title: "订单编号"
  },
  {
    dataIndex: "userName",
    key: "userName",
    align: "center",
    title: "用户姓名"
  },
  /* {
     dataIndex: "phone",
     key: "phone",
     align: "center",
     title: "手机号"
   },*/
  {
    dataIndex: "idCard",
    key: "idCard",
    align: "center",
    title: "身份证号"
  },
  /* {
     dataIndex: "email",
     key: "email",
     align: "center",
     title: "邮箱"
   },*/
  {
    dataIndex: "payprice",
    key: "payprice",
    align: "center",
    title: "支付金额"
  },
  {
    dataIndex: "totalprice",
    key: "totalprice",
    align: "center",
    title: "订单总金额"
  },
  {
    dataIndex: "paytime",
    key: "paytime",
    align: "center",
    title: "支付时间"
  },
  {
    dataIndex: "paymentMethod",
    key: "paymentMethod",
    align: "center",
    title: "支付类型",
    scopedSlots: { customRender: "paymentMethod" }
  }
];

export default {
  name: "userlist",
  data() {
    return {
      isloading: false,
      /** 列表显示模块 */
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      info: {
        totalCount: 0,
        todayCount: 0,
        totalPrice: 0,
        todayPrice: 0,
        subtotal: 0,
        renshu:0
      },
      statusList: {
        paymentMethodStatus: true,//支付方式控制器
        groupDisableStatus: true,//用户组状态控制器
        adminStatus: true,//主管部门状态控制器
        exportButStatus: true //导出按钮状态控制器
      },
      baseConfig: {
        //层级 支付方式
        pay_method_cast: [],
        //列表 支付方式
        pay_method_line: []
      },
      /** 查询条件模块 */
      where: {
        //向后端传递的查询数据
        keyword: {
          orderId: "",//订单编号
          name: "",//用户名称
          dataZone: [],//子站ID
          startTime: "",//付款开始时间
          endTime: "",//付款结束时间
          paymentMethod: "",//支付类型
          paymentType: "",//支付方式
          groupId: "",//用户组
          province: '',//省
          city: '',//市
          area: '',//区
          enterpriseName: "",//单位名称
          administration: "",//主管部门
          howToRegister: "",//注册方式
          pageNow: 1,//默认首页
          pageSize: 10,//默认查询长度
          is_tag: 3
        },

        /*************以下页面展示的option数据***************/
        //站点集合
        subsListOption: [],
        //注册方式
        paymentTypeOption: [
          { name: "线上", val: 1 }, { name: "线下", val: 2 }
        ],
        //用户主
        grouplist: [],
        //主管部门
        administrationList: [],
        //注册方式
        howToRegisterList: [{ value: "0", name: '个人注册' }, { value: "2", name: '系统导入' }],
        //区域列表
        areas: [],
        //子站集合
        subsites: [],
        //支付类型集合
        paymentMethodList: [],
        //线上支付方式集合
        onlineList: [
          {value: 'wechatqr', name: '微信扫码'}, {value: 'wechatjs', name: '微信支付'},
          {value: 'alipayqr', name: '支付宝扫码'}, {value: 'chinaums', name: '银联商务'},
          {value: 'wechatapp', name: '微信APP'}, {value: 'alipayapp', name: '支付宝APP'},
          {value: 'xbsd', name: '移动支付(西北师大)'}, {value: 'jilin', name: '移动支付(长春工大)'},
          {value: 'jiuzhou', name: '移动支付(四川九洲)'}, {value: 'cqut', name: '移动支付(重庆理工)'},
          {value: 'zhixiao', name: '移动支付(知校)'}, {value: 'sxu', name: '移动支付(山西大学)'},
          {value: 'sxxz', name: '移动支付(山西忻州)'}, {value: 'gsdk', name: '移动支付(甘肃地矿)'},
          {value: 'sczj', name: '移动支付(成都理工)'}, {value: 'ggzj', name: '移动支付(桂林理工)'},
          {value: 'jszj', name: '移动支付(南京工业)'}, {value: 'njkc', name: '移动支付(南京勘察)'},
          {value: 'hnnj', name: '移动支付(湖南南京)'}, {value: 'szu', name: '移动支付(深大)'},
          {value: 'gsnx', name: '移动支付(甘肃农信)'}, {value: 'yzzj', name: '移动支付(扬州专技)'},{value: 'ghatg', name: '移动支付(公航旅)'}, {value: 'heu', name: '移动支付(哈工程)'},
          {value: 'zjnl', name: '移动支付(农林大)'}],
        //线下支付方式集合
        offlineList: [{ value: '线下支付', name: '线下支付' }, { value: 'wallet', name: '余额支付' }],
      },
      onlineList: [
        {
          value: 'wechatqr',
          name: '微信扫码'
        },
        {
          value: 'wechatjs',
          name: '微信支付'
        },
        {
          value: 'alipayqr',
          name: '支付宝扫码'
        },
        {
          value: 'chinaums',
          name: '银联商务'
        },
        {
          value: 'wechatapp',
          name: '微信APP'
        },
        {
          value: 'alipayapp',
          name: '支付宝APP'
        },
        {
          value: 'xbsd',
          name: '移动支付(西北师大)'
        },
        {
          value: 'jilin',
          name: '移动支付(长春工大)'
        },
        {
          value: 'jiuzhou',
          name: '移动支付(四川九洲)'
        },
        {
          value: 'cqut',
          name: '移动支付(重庆理工)'
        },
        {
          value: 'zhixiao',
          name: '移动支付(知校)'
        },
        {
          value: 'sxu',
          name: '移动支付(山西大学)'
        },
        {
          value: 'sxxz',
          name: '移动支付(山西忻州)'
        },
        {
          value: 'gsnx',
          name: '移动支付(甘肃农信)'
        }, {
          value: 'gsdk',
          name: '移动支付(甘肃地矿)'
        }, {
          value: 'sczj',
          name: '移动支付(成都理工)'
        }, {
          value: 'ggzj',
          name: '移动支付(桂林理工)'
        }, {
          value: 'jszj',
          name: '移动支付(南京工业)'
        }, {
          value: 'njkc',
          name: '移动支付(南京勘察)'
        },
        {
          value: 'yzzj',
          name: '移动支付(扬州专技)'
        },
        {
          value: 'ghatg',
          name: '移动支付(公航旅)'
        },
        {
          value: 'zjnl',
          name: '移动支付(农林大)'
        },
        {
          value: 'heu',
          name: '移动支付(哈工程)'
        },
        {
          value: 'hnnj',
          name: '移动支付(湖南南京)'
        },
        {
          value: 'szu',
          name: '移动支付(深大)'
        },
      ],
      offlineList: [
        {
          value: '线下支付',
          name: '线下支付'
        },
        {
          value: 'wallet',
          name: '余额支付'
        },
      ],
      moldList:{
        "1":{
          "online":"线上支付",
          "offline":"线下支付",
          "wallets":"余额支付",
        },
        "2":{
          "online":"线上退款",
          "wallets":"余额退款",
        },
        "3":{
          "余额充值":"余额充值"
        }
      },

      searchForm:{
        data_zone:[],
        rangTime:[],
        groupIds:'',
        areas:[],
        administration:'',
        enterpriseName:'',
        howToRegister: ""//注册方式

      },
      tableList:{
        columns:[
          {
            dataIndex: "mold",
            key: "mold",
            align: "center",
            title: "类型",
            customRender:function(text,row,index){
              return {
                children:<a href="javascript:;">{row.mold_text}</a>,
                attrs:{
                  rowSpan:parseInt(row['rowspan'])
                }
              }
            }
          },
          {
            dataIndex: "method",
            key: "method",
            align: "center",
            title: "方式",
            scopedSlots: { customRender: "method" }
          },
          {
            dataIndex: "counts",
            key: "counts",
            align: "center",
            title: "订单笔数（人次）"
          },
          {
            dataIndex: "renshu",
            key: "renshu",
            align: "center",
            title: "人数"
          },
          {
            dataIndex: "amount",
            key: "amount",
            align: "center",
            title: "订单金额（元）",
            scopedSlots: { customRender: "amount" }
          },
          {
            dataIndex: "total",
            key: "total",
            align: "center",
            title: "合计（元）",
            customRender:function(text,row,index){
              return {
                children:row.type == 1||row.type==3?<a href="javascript:;">{row.totalamount}</a>:<a href="javascript:;">-{row.totalamount}</a>,
                attrs:{
                  rowSpan:parseInt(row['rowspan'])
                }
              }
            }
          },
          {
            dataIndex: "totalAll",
            key: "totalAll",
            align: "center",
            title: "收入（元）",
            customRender: (value, row, index) => {
              let that = this;
              if(index == 0 ){
                if(that.tableList.data[that.tableList.data.length-1].method=='wallet'){
                  return {
                    children: that.tableList.totalAmount,
                    attrs: {rowSpan:that.tableList.data.length-1},
                  };
                }else{
                  return {
                    children: that.tableList.totalAmount,
                    attrs: {rowSpan:that.tableList.data.length},
                  };
                }

              }else{
                if(index == that.tableList.data.length-1 && that.tableList.data[that.tableList.data.length-1].method=='wallet'){
                  return {
                    children: '/',
                    attrs: {rowSpan:1},
                  };
                }else{

                  return {
                    children: '',
                    attrs: {rowSpan:0},
                  };
                }
              }

            },
          },
        ],
        data:[],
        totalAmount:0,
        rowspan:{},
        grouplist:[],
        administrationList:[],
        loading:false
      }

    };
  },
  components: {},
  mounted: function () {
    this.$nextTick(function () {
      this.where.areas = this.$api.city.city;
      that = this;
      this.getDictionaryItem();
      this.getSubsites();
      this.getBaseConfig();
    });
  },
  watch: {
    selectRows: function () {
    },
    'searchForm.data_zone': {
      handler:function (nv,ov){
        this.tableList.grouplist = [];
        this.searchForm.groupIds = '';
        this.searchForm.administration = '';
        if(this.searchForm.data_zone.length == 1){
          this.$api.usergroup
              .getGroupIdByDataZone({ dataZone: this.searchForm.data_zone[0] })
              .then(res => {
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.tableList.grouplist = res.data;
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.error();
              });
        }

      },
      immediate:true
    }

  },
  methods: {
    exportStatistics:function(){
      window.location.href = this.$api.financeStatistics.exportStatistics(
          this.searchForm
      );
    },
    search:async function(){
      this.tableList.loading = true;
      this.tableList.data = [];
      this.tableList.totalAmount = 0;
      var res = await this.$api.financeStatistics.getFinanceStatistics(this.searchForm);
      this.tableList.loading = false;
      if(res.errorCode == '0000'){
        this.tableList.data = res.data.lists;
        this.tableList.totalAmount = res.data.total;
        let methodAll = this.onlineList.concat(this.offlineList);
        this.tableList.data.forEach((a,b)=>{
          a.mold_text = this.moldList[a.type][a.mold]?this.moldList[a.type][a.mold]:'未知';
          let m = methodAll.find(function (item){
            return item.value = a.method;
          })
          a.method_text = m!=undefined ?m.name:a.method;
        })
      }
    },


    /**按钮区 */
    searchList() {//点击搜索按钮
      this.list.pagination.current = 1
      this.where.keyword.pageNow = 1
      this.getStatPageListByDataZone();
    },
    //过滤搜索结果 输入关键字出相应的搜索结果
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    /**初始化数据区域 */
    //初始化搜索用户信息
    getStatPageListByDataZone() {
      this.isloading = true;
      var param = this.where.keyword;
      this.$api.order
          .orderStatListByDataZone(param)
          .then(res => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              this.list.datas = res.data.records;
              this.list.pagination.total = Number(res.data.total);
              this.info.subtotal = 0;
              res.data.records.forEach(function (item, index) {
                that.info.subtotal += item.payprice;
              });
              this.info.subtotal = Math.ceil(this.info.subtotal * 100) / 100;
              this.info.totalCount = res.data.total;
              this.info.totalPrice =
                  res.data.totalPrice == null ? 0 : res.data.totalPrice;
              this.info.renshu = res.data.renshu;
            } else {
              this.$message.error(res.errorMsg);
            }
          })
          .catch((e) => {
            this.isloading = false;
            // console.log(e);
            // this.error();
          });
    },
    //初始化用户主
    getgrouplist() {
      this.$api.usergroup
          .getGroupIdByDataZone({ dataZone: this.where.keyword.dataZone[0] })
          .then(res => {
            if (res.errorCode == this.$msg.responseCode.success) {
              this.where.grouplist = res.data;
            } else {
              this.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.error();
          });
    },
    //获取主管部门列表
    getDictionaryItem() {
      this.$api.dictionaryItem.tree(23).then((res) => {
        if (res.errorCode == this.$msg.responseCode.success) {
          this.where.administrationList = res.data;
        } else {
          this.error(res.errorMsg);
        }
      });
    },
    //获取子站集合
    getSubsites() {
      this.$api.area.getAllSubsitesList().then((res) => {
        if (res.errorCode == this.$msg.responseCode.success) {
          this.where.subsites = res.data
        } else {
          this.error(res.errorMsg);
        }
      })
          .catch(() => {
            this.error();
          });
    },
    //导出用户数据
    exportData() {
      window.location.href = this.$api.financeStatistics.exportFinanceStatByDataZone(this.where.keyword);
    },
    /**选项区*/
    //日期选择 开始时间，结束时间
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    // 选择区域 省市县
    onAreachange(v) {
      this.where.keyword.province = v[0] ? v[0] : "";
      this.where.keyword.city = v[1] ? v[1] : "";
      this.where.keyword.area = v[2] ? v[2] : "";
    },
    //赋值用户组
    groupChanged(v) {
      this.where.keyword.groupId = v ? v : ''
    },
    //赋值主管部门
    administrationChanged(v) {
      this.where.keyword.administration = v ? v : "";
    },
    //清除动作
    sourceTypeChange(v) {
      this.where.keyword.sourceType = v > 0 ? v : v == 0 ? 0 : "";
    },
    //切换页码
    pageChange(v) {
      this.list.pagination.current=v.current
      this.where.keyword.pageNow = v.current
      this.getStatPageListByDataZone();
    },
    //初始化支付方式
    getBaseConfig() {
      var params = {
        configList: ['pay_method_cast', 'pay_method_line']
      }
      this.$api.baseConfig.getBaseConfig(params).then(
          res => {
            if (res.errorCode == that.$msg.responseCode.success) {
              this.baseConfig = res.data;
            } else {
              this.error(res.errorMsg);
            }
          }
      );
    },
    //选择支付方式
    paymentMethodChanged(v) {
      that.where.keyword.paymentMethod = []
      if (v.length > 1) {
        this.where.keyword.paymentMethod = [v[1]]
      } else if (v.length == 1) {
        this.baseConfig.pay_method_cast.forEach(function (e) {
          if (e['label'] == v[0]) {
            e['children'].forEach(function (item) {
              that.where.keyword.paymentMethod.push(item['label']);
            })
          }
        })
      }
    },
    //子站选择项目变化
    changeDataZone(v, i) {
      this.where.grouplist = [];
      this.where.keyword.groupId = "";
      if (v && v.length == 1) {
        this.getgrouplist();
        this.statusList.groupDisableStatus = false;
        this.statusList.adminStatus = false;
        this.statusList.exportButStatus = false;
      } else {
        this.statusList.groupDisableStatus = true;
        this.statusList.adminStatus = true;
        this.statusList.exportButStatus = true;
        //this.where.keyword.dataZone="";
      }
    },
    //注册方式
    howToRegisterChange(val) {
      if (val) {
        this.where.keyword.sourceType = val;
      } else {
        this.where.keyword.sourceType = "";
      }
    },
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}

.cang_sta {
  text-align: center;
}

.cang_sta img {
  width: 35px;
}
</style>

